<div
    nz-tooltip
    [nzTooltipTitle]="error"
    [nzTooltipColor]="'red'"
    [ngStyle]="{
        'background-color': error ? '#F05C4D' : edit ? '#e9f7f3' : '#5CC4B6'
    }"
    style="
        margin: 5px;
        border-radius: 10px;
        display: flex;
        border: 1px solid rgba(0, 0, 0, 0.3);
    "
>
    <!-- time -->
    <div style="
            padding: 5px 10px;
            display: flex;
            align-items: center;
            justify-content: center;
        ">
        <ng-container *ngIf="edit; else readOnlyTpl">
            <nz-time-picker
                style="width: 90px"
                nzFormat="h:mm a"
                nzPlaceHolder="start"
                [nzMinuteStep]="cronRate"
                [nzSuffixIcon]="null"
                [nzAllowEmpty]="false"
                [(ngModel)]="start"
                [nzUse12Hours]="true"
                (ngModelChange)="changeHandler()"
                [nzMinuteStep]="15"
            ></nz-time-picker>
        </ng-container>

        <ng-template #readOnlyTpl>
            <div style="color: white; font-weight: 500">
                {{ start | date: 'h:mm a' }}
            </div>
        </ng-template>
    </div>
    <!-- actions -->
    <div
        *ngIf="edit"
        style="
            border-left: 1px solid rgba(0, 0, 0, 0.3);
            padding: 2px 10px;
            display: flex;
            flex-direction: column;
            justify-content: center;
        "
    >
        <div>
            <i
                style="color: red; cursor: pointer"
                nz-icon
                nzType="close"
                nzTheme="outline"
                (click)="delete()"
            ></i>
        </div>
    </div>
</div>